import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, IvfEmbryoGradingByCycleController, IvfEmbryoGradingByCycleRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { OocyteStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfoqaedit.component';
import { EmbryoStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfgradingedit.component';




@Component({
  selector: 'embryogradingdroplet',
  templateUrl: './embryogradingdroplet.component.html',
  styleUrls: ['./embryogradingdroplet.component.scss']
})

export class EmbryogradingDropletPVComponent implements OnInit {

  //@Input() CycleCode: number;
  //@Input() TitleText: string;
  //@Input() DOC: string;

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public EndometriumThickness: number;
  public LeftOvaries: number;
  public RightOvaries: number;
  public MedicineName: string;
  public TestName: string;
  public TestName1: string;
  public Owner: string;
  public FormattedCode: string;
  public Protocolst: string;
  public ProtocolEd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public Age: string;
  public CycleNo: string;
  public CycleType: string;
  public TotalOocytes: string;
  public Date: Date;
  public TransferedCount: number;
  public FrozenCount: number;
  public DiscardedCount: number;
  public TotalCout: number;
  public TreatmentCycleCodedata: any
  public EggSourceData: string;
  public DonorData: string;
  public DonorCode: string;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public Doc: string;
  public DocDate: string;

  CurrentIvfEmbryoGradingByCycleDOC1Controller: IvfEmbryoGradingByCycleController[];
  CurrentIvfEmbryoGradingByCycleDOC1Request: IvfEmbryoGradingByCycleRequest;

  LoadGradingDataDOC1() {
    //alert("ScansData")
    this.CurrentIvfEmbryoGradingByCycleDOC1Request = new IvfEmbryoGradingByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfEmbryoGradingByCycleDOC1Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoGradingByCycleController();
  }

  GetIvfEmbryoGradingByCycleController() {
    //  alert(this.DOC);
    this.CurrentIvfEmbryoGradingByCycleDOC1Request.ConditionalOperator = 101;
    this.CurrentIvfEmbryoGradingByCycleDOC1Request.CycleCode = this.TreatmentCycleCodedata;
    this.CurrentIvfEmbryoGradingByCycleDOC1Request.DOC = "1";


    this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleDOC1Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfEmbryoGradingByCycleDOC1Controller = this.ApiResData.Result;

          //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
          //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
          //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
          //    function (v, i, d) {
          //    //if (v.DOC.toString() == this.DOC)
          //    //    alert('Mmmmmm');
          //        return this.checkDoc(v.DOC);//.toString() == this.DOC
          //});
          this.stopRefreshing();
          this.LoadGradingDataDOC2();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfEmbryoGradingByCycleDOC2Controller: IvfEmbryoGradingByCycleController[];
  CurrentIvfEmbryoGradingByCycleDOC2Request: IvfEmbryoGradingByCycleRequest;

  LoadGradingDataDOC2() {
    //alert("ScansData")
    this.CurrentIvfEmbryoGradingByCycleDOC2Request = new IvfEmbryoGradingByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfEmbryoGradingByCycleDOC2Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoGradingByCycleControllerDOC2();
  }

  GetIvfEmbryoGradingByCycleControllerDOC2() {
    //  alert(this.DOC);
    this.CurrentIvfEmbryoGradingByCycleDOC2Request.ConditionalOperator = 101;
    this.CurrentIvfEmbryoGradingByCycleDOC2Request.CycleCode = this.TreatmentCycleCodedata;
    this.CurrentIvfEmbryoGradingByCycleDOC2Request.DOC = "2";


    this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleDOC2Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfEmbryoGradingByCycleDOC2Controller = this.ApiResData.Result;
          //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
          //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
          //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
          //    function (v, i, d) {
          //    //if (v.DOC.toString() == this.DOC)
          //    //    alert('Mmmmmm');
          //        return this.checkDoc(v.DOC);//.toString() == this.DOC
          //});
          this.stopRefreshing();
          this.LoadGradingDataDOC3();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfEmbryoGradingByCycleDOC3Controller: IvfEmbryoGradingByCycleController[];
  CurrentIvfEmbryoGradingByCycleDOC3Request: IvfEmbryoGradingByCycleRequest;

  LoadGradingDataDOC3() {
    //alert("ScansData")
    this.CurrentIvfEmbryoGradingByCycleDOC3Request = new IvfEmbryoGradingByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfEmbryoGradingByCycleDOC3Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoGradingByCycleControllerDOC3();
  }

  GetIvfEmbryoGradingByCycleControllerDOC3() {
    //  alert(this.DOC);
    this.CurrentIvfEmbryoGradingByCycleDOC3Request.ConditionalOperator = 101;
    this.CurrentIvfEmbryoGradingByCycleDOC3Request.CycleCode = this.TreatmentCycleCodedata;
    this.CurrentIvfEmbryoGradingByCycleDOC3Request.DOC = "3";


    this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleDOC3Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfEmbryoGradingByCycleDOC3Controller = this.ApiResData.Result;
          //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
          //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
          //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
          //    function (v, i, d) {
          //    //if (v.DOC.toString() == this.DOC)
          //    //    alert('Mmmmmm');
          //        return this.checkDoc(v.DOC);//.toString() == this.DOC
          //});
          this.stopRefreshing();
          this.LoadGradingDataDOC4();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfEmbryoGradingByCycleDOC4Controller: IvfEmbryoGradingByCycleController[];
  CurrentIvfEmbryoGradingByCycleDOC4Request: IvfEmbryoGradingByCycleRequest;

  LoadGradingDataDOC4() {
    //alert("ScansData")
    this.CurrentIvfEmbryoGradingByCycleDOC4Request = new IvfEmbryoGradingByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfEmbryoGradingByCycleDOC4Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoGradingByCycleControllerDOC4();
  }

  GetIvfEmbryoGradingByCycleControllerDOC4() {
    //  alert(this.DOC);
    this.CurrentIvfEmbryoGradingByCycleDOC4Request.ConditionalOperator = 101;
    this.CurrentIvfEmbryoGradingByCycleDOC4Request.CycleCode = this.TreatmentCycleCodedata;
    this.CurrentIvfEmbryoGradingByCycleDOC4Request.DOC = "4";


    this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleDOC4Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfEmbryoGradingByCycleDOC4Controller = this.ApiResData.Result;
          //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
          //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
          //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
          //    function (v, i, d) {
          //    //if (v.DOC.toString() == this.DOC)
          //    //    alert('Mmmmmm');
          //        return this.checkDoc(v.DOC);//.toString() == this.DOC
          //});
          this.stopRefreshing();
          this.LoadGradingDataDOC5();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfEmbryoGradingByCycleDOC5Controller: IvfEmbryoGradingByCycleController[];
  CurrentIvfEmbryoGradingByCycleDOC5Request: IvfEmbryoGradingByCycleRequest;

  LoadGradingDataDOC5() {
    //alert("ScansData")
    this.CurrentIvfEmbryoGradingByCycleDOC5Request = new IvfEmbryoGradingByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfEmbryoGradingByCycleDOC5Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoGradingByCycleControllerDOC5();
  }

  GetIvfEmbryoGradingByCycleControllerDOC5() {
    //  alert(this.DOC);
    this.CurrentIvfEmbryoGradingByCycleDOC5Request.ConditionalOperator = 101;
    this.CurrentIvfEmbryoGradingByCycleDOC5Request.CycleCode = this.TreatmentCycleCodedata;
    this.CurrentIvfEmbryoGradingByCycleDOC5Request.DOC = "5";


    this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleDOC5Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfEmbryoGradingByCycleDOC5Controller = this.ApiResData.Result;
          //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
          //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
          //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
          //    function (v, i, d) {
          //    //if (v.DOC.toString() == this.DOC)
          //    //    alert('Mmmmmm');
          //        return this.checkDoc(v.DOC);//.toString() == this.DOC
          //});
          this.stopRefreshing();
          this.LoadGradingDataDOC6();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfEmbryoGradingByCycleDOC6Controller: IvfEmbryoGradingByCycleController[];
  CurrentIvfEmbryoGradingByCycleDOC6Request: IvfEmbryoGradingByCycleRequest;

  LoadGradingDataDOC6() {
    //alert("ScansData")
    this.CurrentIvfEmbryoGradingByCycleDOC6Request = new IvfEmbryoGradingByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfEmbryoGradingByCycleDOC6Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoGradingByCycleControllerDOC6();
  }

  GetIvfEmbryoGradingByCycleControllerDOC6() {
    //  alert(this.DOC);
    this.CurrentIvfEmbryoGradingByCycleDOC6Request.ConditionalOperator = 101;
    this.CurrentIvfEmbryoGradingByCycleDOC6Request.CycleCode = this.TreatmentCycleCodedata;
    this.CurrentIvfEmbryoGradingByCycleDOC6Request.DOC = "6";


    this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleDOC6Request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfEmbryoGradingByCycleDOC6Controller = this.ApiResData.Result;
          //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
          //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
          //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
          //    function (v, i, d) {
          //    //if (v.DOC.toString() == this.DOC)
          //    //    alert('Mmmmmm');
          //        return this.checkDoc(v.DOC);//.toString() == this.DOC
          //});
          this.stopRefreshing();
          this.LoadPatients();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  LoadPatients() {
    this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;
    this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date(2017, 1, 1);// "1-JAN-2017";
    this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();// "31-DEC-2018";
    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetCycleOocyteQualityBetweenDateController();
  }

  GetCycleOocyteQualityBetweenDateController() {
    this.StartRefreshing();


    this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();

    this.Doc = this.route.snapshot.paramMap.get('Doc');
    this.DocDate = this.route.snapshot.paramMap.get('DocDate');
    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.FormattedCode = this.route.snapshot.paramMap.get('PatientId');
    this.Protocolst = this.route.snapshot.paramMap.get('ProtocolStart');
    this.ProtocolEd = this.route.snapshot.paramMap.get('ProtocolEnd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    this.TotalOocytes = this.route.snapshot.paramMap.get('TotalOocytes');
    this.TreatmentCycleCodedata = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.EggSourceData = this.route.snapshot.paramMap.get('EggSourceData');
    this.DonorData = this.route.snapshot.paramMap.get('DonorData');
    this.DonorCode = this.route.snapshot.paramMap.get('DonorCode');

    this.LoadGradingDataDOC1();

  }
  GetMaxDOC(l: SingleWellCultureByCycleCodeController): number {
    if (l.DocID1 != null) {
      return l.DOC1
    }
    else if (l.DocID2 != null) {
      return l.DOC2
    }
    else if (l.DocID3 != null) {
      return l.DOC3
    }
    else if (l.DocID4 != null) {
      return l.DOC4
    }
    else if (l.DocID5 != null) {
      return l.DOC5
    }
    else if (l.DocID6 != null) {
      return l.DOC6
    }
    return 0;

  }

  GetMaxGrade(l: SingleWellCultureByCycleCodeController): string {
    if (l.Grade6 != null) {
      return l.Grade6
    }
    else if (l.Grade5 != null) {
      return l.Grade5
    }
    else if (l.Grade4 != null) {
      return l.Grade4
    }
    else if (l.Grade3 != null) {
      return l.Grade3
    }
    else if (l.Grade2 != null) {
      return l.Grade2
    }
    else if (l.Grade1 != null) {
      return l.Grade1
    }
    return "";

  }
  GetMaxImage(l: SingleWellCultureByCycleCodeController): number {
    if (l.Image6 != null) {
      return l.Image6
    }
    else if (l.Image5 != null) {
      return l.Image5
    }
    else if (l.Image4 != null) {
      return l.Image4
    }
    else if (l.Image3 != null) {
      return l.Image3
    }
    else if (l.Image2 != null) {
      return l.Image2
    }
    else if (l.Image1 != null) {
      return l.Image1
    }
    return 0;

  }
  GetMaxImageUrl(l: SingleWellCultureByCycleCodeController): string {
    if (l.DocID6 != null) {
      return l.DocFriendlyName6
    }
    else if (l.DocID5 != null) {
      return l.DocFriendlyName5
    }
    else if (l.DocID4 != null) {
      return l.DocFriendlyName4
    }
    else if (l.DocID3 != null) {
      return l.DocFriendlyName3
    }
    else if (l.DocID2 != null) {
      return l.DocFriendlyName2
    }
    else if (l.DocID1 != null) {
      return l.DocFriendlyName1
    }
    return null;

  }
  //GetImageUrl(l: SingleWellCultureByCycleCodeController, doc: number): string {
  //  //this.IsGradingCompleted


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








